import { Button, Typography, Flex } from '@jisr-hr/ds'
import { useDispatch, useSelector } from 'utils/hooks'
import DSIcon from 'components/DSIcon'
import HelpCenter from 'components/NewNavigation/HelpCenter'
import OnboardingInviteEmployees from 'components/NewNavigation/OnboardingInviteEmployees'
import { Dispatch, FC, SetStateAction, useState } from 'react'
import i18n from 'translations/i18n'
import { isRouteMatch, isRtl } from 'utils/uiHelpers'
import { labels } from 'utils/whitelabel'
import { onboardingChangeTourStep } from 'redux/authUser/actionCreators'
import OnboardingTour from 'containers/authorised/NewOnboarding/components/OnboardingTour'
import styles from './styles.module.css'
import GetHelp from './GetHelp/GetHelp'

type Props = {
  setOnboardingInviteModalOpen: Dispatch<SetStateAction<boolean>>
}

const OnboardingHeader: FC<Props> = ({ setOnboardingInviteModalOpen }) => {
  const dispatch = useDispatch()
  const employee = useSelector((s) => s.auth.employee)
  const stepTour = useSelector((s) => s.auth.step_tour)
  const onboardingSteps = useSelector((s) => s.onboardingHeaderSteps)
  const { is_employees_invited: isEmployeeInvited } = useSelector(
    (s) => s.invitationsTracking.invitationsStatistics,
  )
  const imageTourInviteAdmin = isRtl
    ? 'https://jisr-public.s3.me-south-1.amazonaws.com/images/Tour-Invite-Admin-AR.gif'
    : 'https://jisr-public.s3.me-south-1.amazonaws.com/images/Tour-Invite-Admin-EN+.gif'
  const [isOpenDrawer, setIsOpenDrawer] = useState(false)

  return (
    <>
      {!onboardingSteps.title && isRouteMatch('org_info') && (
        <OnboardingTour
          open={stepTour === 2}
          position={isRtl ? 'bottom-end' : 'bottom-start'}
          text={i18n.t(
            'description.invite_more_admins_to_help_you_with_completing_org_name_workspace_data',
            {
              company_name: employee?.organization?.slug,
            },
          )}
          trigger={
            <Button
              size="sm"
              variant="secondary"
              label={i18n.t('label.invite_admins')}
              iconLeading={<DSIcon name="user-plus-02" />}
              onClick={(): void => setOnboardingInviteModalOpen(true)}
            />
          }
          content={
            <img
              alt="onboarding-tour"
              src={imageTourInviteAdmin}
              style={{
                width: 296,
                height: 180,
                borderRadius: 8,
              }}
            />
          }
          footer={
            <Flex
              justifyBetween
              itemsCenter
            >
              <Typography
                variant="caption"
                textColor="color/fg/inverse-light"
                text={i18n.t('tour_step', { step: 1, steps: 2 })}
              />
              <Button
                size="sm"
                type="button"
                variant="secondary"
                onClick={(): void => {
                  dispatch(onboardingChangeTourStep(3))
                }}
              >
                {i18n.t('next')}
              </Button>
            </Flex>
          }
        />
      )}
      {isRouteMatch('modules') && <OnboardingInviteEmployees />}
      {labels.name === 'Jisr' && (
        <>
          {isEmployeeInvited ? (
            <HelpCenter
              target={
                <Button
                  className={onboardingSteps.title ? styles.screenSize : undefined}
                  size="sm"
                  // className={unreadMessageCount ? 'helpDot' : ''}
                  label={i18n.t('label.get_help')}
                  variant="tertiary"
                  iconTrailing={
                    <DSIcon
                      size="ml"
                      name="help-circle"
                    />
                  }
                />
              }
            />
          ) : (
            <Button
              className={onboardingSteps.title ? styles.screenSize : undefined}
              size="sm"
              label={i18n.t('label.get_help')}
              variant="tertiary"
              iconTrailing={
                <DSIcon
                  size="ml"
                  name="help-circle"
                />
              }
              onClick={(): void => setIsOpenDrawer(true)}
            />
          )}
        </>
      )}

      <GetHelp
        isOpenDrawer={isOpenDrawer}
        onClose={(): void => setIsOpenDrawer(false)}
      />
    </>
  )
}

export default OnboardingHeader
